import User from "@/models/User";

export default class UserInfo {
    user
    concernedCount
    enabledConcernedCount
    keyWords

    constructor(props) {
        const pp = props || {}
        this.user = new User(pp.user || {})
        this.concernedCount = pp.concernedCount || 0
        this.enabledConcernedCount = pp.enabledConcernedCount || 0
        this.keyWords = pp.keyWords || []
    }

}
